angular.module('rightPaneModule')
  .controller('GuardianActivityController', [
      '$scope',
      '$state',
      'activityApi',
      'compareDay',
      'infiniteScroll',
      'authentication',
      'reportErrors',
      'edxDateTimeService',
      'translateFilter',
      function (
          $scope,
          $state,
          $activityApi,
          $compareDay,
          $infiniteScroll,
          dblAuthentication,
          $reportErrors,
          dateTimeService,
          translateFilter)
    {
        var computedFromDate = new Date();
        var computedToDate = new Date().setDate(computedFromDate.getDate() - 29);

        $scope.activityFeedFrom = new Date();
        $scope.activityFeedTo = new Date();

        $scope.activityFeedFrom = computedFromDate;
        $scope.activityFeedTo = computedToDate;

        $scope.fromDateDay = dateTimeService.dayOfWeekOrToday(computedFromDate);
        $scope.toDateDay = dateTimeService.dayOfWeekOrToday(computedToDate);

        var NO_EVENTS_MESSAGE = translateFilter('errors.noEventsStudent');
        var NO_MORE_EVENTS_MESSAGE = translateFilter('errors.noMoreEventsStudent');

        // Track last student for whom we loaded data to help prevent redundant calls
        var lastStudentId;

        $scope.showStudentNames = false; // At the student level no need to display names on the card.

        function updateNoEventsMessage() {
            if (!$scope.events.length && !$scope.busy) {
              $scope.noDataMessage = NO_EVENTS_MESSAGE;
            } else if ($scope.events.length && $scope.endOfPage) {
              $scope.noDataMessage = NO_MORE_EVENTS_MESSAGE;
            } else {
              $scope.noDataMessage = undefined;
            }
        }


        function updateStudentActivities(reset) {
            // If we are resetting but the student hasn't changed then do nothing
            if ($state.params.studentId === lastStudentId && reset) {
                return;
            }
            lastStudentId = $state.params.studentId;

            $scope.activityError = null;
            $activityApi.getStudentActivitiesForGuardian().then(function (data) {
              $infiniteScroll.handlePageResponse($scope, data);

              if (reset) {
                  $scope.events = [];
              }
              $scope.events = ($scope.events || []).concat(data.activities);
              updateNoEventsMessage();
            }, function (error) {
              var message = $reportErrors.getErrorMessage(error);
              $scope.noDataMessage = message ? message : 'Unable to load activities.';
            });
        }

        function initializeData(e, item) {
            $scope.item = item;
        }

        $scope.$on('updateStudentDataForGuardian', function (event) {
          // IN-618 include today
          $compareDay.resetGroupedByDate(true);
          $scope.events = [];
          updateStudentActivities(true);
        });

        $scope.$on('itemReady', initializeData);
        $infiniteScroll.init($scope, function() {updateStudentActivities(false);});

  }]);
